export default __webpack_public_path__ + "static/media/card-fuzzy-plus-color.c7c47404.jpg";